import React from "react";
import { Container, Stack } from "@mui/material";
import VehicleSearchPanel from "../components/VehicleSearchPanel";
import { useSupply } from "../context/SupplyContext";

export default function VehicleSearchPage() {
  const { vehicle, setVehicle } = useSupply();

  const handleVehicleSelection = React.useCallback(
    (context) => {
      if (!context) {
        return;
      }
      setVehicle(context);
    },
    [setVehicle]
  );

  const handleVinSubmit = React.useCallback(
    (vin) => {
      if (!vin) {
        return;
      }
      setVehicle({ type: "vin", lookupType: "VIN", vin });
    },
    [setVehicle]
  );

  const handleHsnTsnSubmit = React.useCallback(
    ({ hsn, tsn }) => {
      setVehicle({ type: "hsn-tsn", lookupType: "HSN_TSN", hsn, tsn });
    },
    [setVehicle]
  );

  const handleReset = React.useCallback(() => {
    setVehicle(null);
  }, [setVehicle]);

  return (
    <Container sx={{ py: 4 }}>
      <Stack spacing={3}>
        <VehicleSearchPanel
          vehicle={vehicle}
          onVehicleSelection={handleVehicleSelection}
          onVinSubmit={handleVinSubmit}
          onHsnTsnSubmit={handleHsnTsnSubmit}
          onReset={handleReset}
        />
      </Stack>
    </Container>
  );
}
